import { gql } from "gql";

export const SEND_REACTION = gql(/* GraphQL */ `
  mutation SendReaction($postId: ID!, $reaction: String!) {
    sendReaction(postId: $postId, reaction: $reaction)
  }
`);
